var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"taskContainer",attrs:{"data-cy":"mypage_single_task"}},[_c('Task',_vm._b({on:{"click":function($event){return _vm.$emit('click', $event)}}},'Task',_vm.parsedTask,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }